import React from "react";

export default function RefundPolicy() {
  return (
    <div style={{ paddingTop: 80, paddingBottom: 80, minHeight: "100vh" }}>
      <div className="container" style={{ maxWidth: 900 }}>
        <h1 style={{ fontSize: 32, fontWeight: 800, marginBottom: 32 }}>Refund Policy</h1>
        <div style={{ lineHeight: 1.8, color: "#c0c0e0" }}>
          
          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Overview</h2>
          <p>At Ariyom Tech Solutions, we are committed to providing quality internship services. This refund policy outlines the terms under which students may request refunds for their internship registration fee.</p>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Refund Eligibility</h2>
          <p>Refunds are available under the following conditions:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li><strong>Within 7 days of registration:</strong> Full refund if the student has not started the internship program.</li>
            <li><strong>8-14 days of registration:</strong> 50% refund if the student is within the first 14 days and has submitted less than 25% of tasks.</li>
            <li><strong>After 14 days:</strong> No refund is provided as the internship is in active progress.</li>
            <li><strong>Payment verification failure:</strong> Full refund if payment cannot be verified or payment receipt is invalid.</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Non-Refundable Scenarios</h2>
          <p>The following situations are non-refundable:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>Student voluntarily withdraws after 14 days</li>
            <li>Student's registration is revoked due to misconduct or policy violation</li>
            <li>Student has completed more than 25% of assigned tasks</li>
            <li>Student has received a certificate</li>
            <li>Refund request submitted more than 30 days after registration</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>How to Request a Refund</h2>
          <p>To request a refund, please:</p>
          <ol style={{ paddingLeft: 24 }}>
            <li>Send an email to <strong>support@ariyomtechsolutions.site</strong></li>
            <li>Include your registration email and certificate ID</li>
            <li>Clearly state the reason for the refund request</li>
            <li>Attach any supporting documentation if applicable</li>
          </ol>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Refund Processing</h2>
          <p>Once your refund request is approved:</p>
          <ul style={{ paddingLeft: 24 }}>
            <li>Processing time: 7-10 business days</li>
            <li>Refund will be issued to the original payment method</li>
            <li>You will receive a confirmation email with refund status</li>
            <li>For PhonePe/UPI payments, funds will appear in your registered account</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Important Notes</h2>
          <ul style={{ paddingLeft: 24 }}>
            <li>Refund policy is subject to change at any time without prior notice</li>
            <li>Ariyom Tech Solutions reserves the right to deny refund requests that do not meet eligibility criteria</li>
            <li>All refund decisions are final and cannot be appealed</li>
            <li>Partial refunds are non-refundable</li>
          </ul>

          <h2 style={{ fontSize: 20, fontWeight: 700, marginTop: 24, marginBottom: 12 }}>Contact Us</h2>
          <p>If you have questions about our refund policy, please contact:</p>
          <p style={{ marginTop: 12 }}>
            <strong>Email:</strong> support@ariyomtechsolutions.site<br />
            <strong>Website:</strong> ariyomtechsolutions.site<br />
            <strong>Hours:</strong> Monday - Friday, 10:00 AM - 6:00 PM IST
          </p>

          <p style={{ marginTop: 32, fontSize: 13, color: "#555" }}>Last updated: May 18, 2026</p>
        </div>
      </div>
    </div>
  );
}
